import { StyleSheet } from 'react-native';

import { WebLayout, colors } from '@pletly/ui';
import { MyOrganisations } from './components/MyOrganisations';

export const OrganisationsPage = () => {
	return (
		<WebLayout style={styles.root}>
			<MyOrganisations />
		</WebLayout>
	);
};

const styles = StyleSheet.create({
	root: {
		justifyContent: 'space-between',
		flexDirection: 'column',
		backgroundColor: colors.background200,
	},
});
